<script lang="ts">
  import Highcharts from "highcharts"
  import { GanttChart } from "@highcharts/svelte"
  import ExportingModule from "highcharts/modules/exporting"

  export let series: Highcharts.SeriesOptionsType[] = []
  export let title: string = "Gantt Chart with Navigation"
  export let tooltip: object = {}

  ExportingModule(Highcharts)

  const options: Highcharts.Options = {
    accessibility: {
      enabled: true
    },
    title: {
      text: title,
      useHTML: true
    },
    // plotOptions: {
    //   series: {
    //     dataLabels: {
    //       enabled: true,
    //       format: '{point.name}',
    //     }
    //   }
    // },
    time: {
      useUTC: false
    },
    yAxis: {
      uniqueNames: true,
      reversed: true
    },
    tooltip: tooltip,
    navigator: {
      enabled: true,
      liveRedraw: true,
      series: {
        type: "gantt",
        accessibility: {
          enabled: false,
        },
      },
      yAxis: {
        categories: [],
      },
    },

    scrollbar: {
      enabled: true,
    },

    rangeSelector: {
      enabled: true,
      selected: 7,
      inputDateFormat: "%Y-%m-%d %H:%M:%S",
      buttons: [
        {
          type: "second",
          count: 10,
          text: "10sec",
          title: "View 10 second",
        },
        {
          type: "minute",
          count: 1,
          text: "1min",
          title: "View 1 minute",
        },
        {
          type: "hour",
          count: 1,
          text: "1h",
          title: "View 1 hour",
        },
        {
          type: "hour",
          count: 12,
          text: "12h",
          title: "View 12 hour",
        },
        {
          type: "day",
          count: 1,
          text: "1d",
          title: "View 1 day",
        },
        {
          type: "week",
          count: 1,
          text: "1w",
          title: "View 1 week",
        },
        {
          type: "month",
          count: 1,
          text: "1m",
          title: "View 1 month",
        },
        {
          type: "all",
          text: "all",
          title: "View all",
        },
      ],
    },
    series: series
  }

  $: {
    options.tooltip = tooltip
    options.series = series
    options.title!.text = title
  }
</script>

<GanttChart {options} highcharts={Highcharts} />
